import axiosClient from "./axiosClient";

const createScenario = (params) => {
  const url = "/scenarios";
  return axiosClient.post(url, params);
};

const getMyQuickLoan = async (scenarioId) => {
  if (!scenarioId) {
    throw new Error("scenarioId is required");
  }
  const url = `/scenarios/me/quickloans/${scenarioId}`;
  return axiosClient.get(url);
};

const getMyQuickLoans = async () => {
  const url = "/scenarios/me/quickloans";
  return axiosClient.get(url);
};

const deleteMyQuickLoan = (scenarioId) => {
  if (!scenarioId) {
    throw new Error("scenarioId is required");
  }
  const url = `/scenarios/me/quickloans/${scenarioId}`;
  return axiosClient.delete(url);
};

const createDraftScenario = ({ source = "QUICK_LOAN", updatePayload }) => {
  const url = "/scenarios/draft";
  return axiosClient.post(url, { source, updatePayload });
};

const syncQuickLoanStates = (scenarioId, params) => {
  const url = `/scenarios/${scenarioId}/quickloan/states`;
  return axiosClient.patch(url, params);
};

const updateDraftQuickLoan = (scenarioId, params) => {
  const url = `/scenarios/${scenarioId}/quickloan`;
  return axiosClient.put(url, params);
};

const getScenarioBankAccount = (scenarioId) => {
  const url = `/scenarios/${scenarioId}/bank-accounts`;
  return axiosClient.get(url);
};

const getIncomesAndExpensesSummaryByApplicant = (scenarioId, filter) => {
  const url = `/scenarios/${scenarioId}/incomes-expenses-summary-of-applicant`;
  return axiosClient.post(url, filter);
};

const connectDelegatedApplicantBankAccount = (
  scenarioId,
  coApplicantUserId
) => {
  const url = `/scenarios/${scenarioId}/delegated-connections/${coApplicantUserId}`;
  return axiosClient.post(url);
};

const createQuickLoan = (scenarioId, params) => {
  const url = `/scenarios/${scenarioId}/quickloan`;
  return axiosClient.post(url, params);
};

const getScenario = (selectedJointAccount) => {
  const url = "/scenarios/all";
  return axiosClient.get(url, {
    params: { jointAccountId: selectedJointAccount || undefined },
  });
};

const deleteScenario = (id) => {
  const url = `/scenarios/${id}`;
  return axiosClient.delete(url);
};
const updateScenario = (id, params, isSaveToDB = true) => {
  const url = `/scenarios/${id}/${isSaveToDB ? "true" : "false"}`;
  return axiosClient.put(url, params);
};

const getProductListByScenarioId = (id) => {
  const url = `/scenarios/${id}/getDataAndBuildProductListByScenarioId`;
  return axiosClient.get(url);
};

const uploadDocument = (id, params, options) => {
  const url = `/scenarios/${id}/upLoad`;
  return axiosClient.post(url, params, {
    ...options,
    headers: {
      ...(options?.headers || {}),
      ...(params.getHeaders?.() ?? { "Content-Type": "multipart/form-data" }),
    },
  });
};
const getDocumentList = (id) => {
  const url = `/scenarios/${id}/documentation`;
  return axiosClient.get(url);
};
const createLoanSubmission = (id) => {
  const url = `/scenarios/${id}/loanSubmission`;
  return axiosClient.post(url);
};
const getLoanSubmissionStatus = (id) => {
  const url = `/scenarios/${id}/loanSubmission/status`;
  return axiosClient.get(url);
};
const getDocumentURL = (id, isDownload) => {
  const url = `/scenarios/documentation/${id}/${isDownload}`;
  return axiosClient.get(url);
};
const deleteDocument = (scenarioId, documentId) => {
  const url = `/scenarios/${scenarioId}/documentation/${documentId}`;
  return axiosClient.delete(url);
};

const getNotification = (id) => {
  const url = `/scenarios/${id}/notification`;
  return axiosClient.get(url);
};

const inviteUserToScenario = (payload) => {
  const url = `/scenarios/send-invitation-email`;
  return axiosClient.post(url, payload);
};

const acceptInvitation = (token) => {
  const url = `/scenarios/accept-invitation`;
  return axiosClient.post(url, { token });
};

const validateToken = (token) => {
  const url = `/scenarios/validate-invite-token`;
  return axiosClient.post(url, { token });
};

const getConnectionByScenario = (scenarioId) => {
  const url = `/scenarios/${scenarioId}/invitation`;
  return axiosClient.get(url);
};

const removeUserFromScenario = (scenarioId, email) => {
  const url = `/scenarios/${scenarioId}/remove-member`;
  return axiosClient.post(url, { email });
};

const getScenarioFinanceHistory = (options) => {
  const url = `/scenarios/finance-history`;
  return axiosClient.get(url, { params: options });
};

const updateScenarioV2 = (id, params) => {
  const url = `/scenarios/${id}`;
  return axiosClient.put(url, params);
};

const sendOpenBankingAccessRequest = (payload) => {
  const url = `/scenarios/open-banking-access-request`;
  return axiosClient.post(url, payload);
};

const acceptOpenBankingAccessRequest = (token) => {
  const url = `/scenarios/open-banking-access-request/accept?token=${token}`;
  return axiosClient.get(url);
};

export {
  getLoanSubmissionStatus,
  deleteDocument,
  createLoanSubmission,
  getNotification,
  getDocumentURL,
  getDocumentList,
  uploadDocument,
  createScenario,
  getScenario,
  deleteScenario,
  getProductListByScenarioId,
  updateScenario,
  inviteUserToScenario,
  acceptInvitation,
  getConnectionByScenario,
  validateToken,
  removeUserFromScenario,
  createQuickLoan,
  createDraftScenario,
  updateDraftQuickLoan,
  syncQuickLoanStates,
  getMyQuickLoan,
  getMyQuickLoans,
  deleteMyQuickLoan,
  getScenarioBankAccount,
  connectDelegatedApplicantBankAccount,
  getIncomesAndExpensesSummaryByApplicant,
  getScenarioFinanceHistory,
  updateScenarioV2,
  sendOpenBankingAccessRequest,
  acceptOpenBankingAccessRequest,
};
